<template>
    <div class="amap-wrapper-show">
        <el-amap class="amap-box" :plugin="plugin" vid="map" :zoom="zoom" :center="center" :events="events">
        <!-- <el-amap-search-box class="search-box" :search-option="searchOption"></el-amap-search-box> -->
        <el-amap-marker v-for="item in markers" :key="item.id" class="amap-marker" :position="item.position" vid="marker" :title="item.title" :label="item.label" :offset="offset"></el-amap-marker>
        </el-amap>
        
        <!-- <div class="adrs">
            <ul>
                <li>
                    <p class="address">{{list.address}}</p>
                    <p class="name">{{list.name}}</p>
                    <p class="position">{{list.lng}},{{list.lat}}</p>
                    <p class="city">{{list.city}}</p>
                    <p class="district">{{list.district}}</p>
                    <p class="township">{{list.township}}</p>
                </li>
            </ul>
        </div> -->
        <!-- <button type="button" class="close" @click="closeMap"><i class="iconfont icon-close fs-14"></i></button> -->
    </div>
</template>

<style lang="sass">
    .amap-wrapper-show .close
        position: absolute;
        width: 40px;
        height: 40px;
        vertical-align: middle;
        top: 15px;
        right: 15px;
        background-color: #fff;
        opacity: 1;
        border: 1px solid #5d5d5d;
        border-radius: 50%;
    .amap-wrapper-show .icon-close
        font-size: 20px !important;
        color: #5d5d5d;
    .amap-hidden
        display: none;
    .amap-show
        display: block;
    .amap-wrapper-show
        position: absolute;
        width: calc(100% - 200px);
        height: 100%;
        z-index: 0;
    .amap-wrapper-show .amap-icon
        width: 35px !important;
        height: 50px !important;
    .amap-wrapper-show .amap-icon img
        width: 35px !important;
        height: 50px !important;
    .amap-wrapper-show .amap-marker-label
        width: 34px;
        height: 0;
        padding: 0;
        text-align: center;
        left: 0;
        top: 9px;
        color: #fff;    
        border: none;
        background-color: transparent;
    .search-tips
        width: 100%;
        max-height: 200px;
    .el-vue-amap-container
        position: relative;
    .el-vue-search-box-container
        position: absolute !important;
        top: 15px;
        left: 15px;
    @media (min-width:300px)
      .amap-wrapper-show
        width: 100%;
</style>

<script>
import { fetch } from '@/utils/api'
export default {
  name: 'amapSelect',
  data () {
    var me = this
    // me.city = me.city || '珠海'
    me.city = me.city
    return {
      list: [],
      zoom: 14,
      center: [113.584672, 22.345392],
      offset: [-15, -48],
      markers: [],
      label: {
        content: '清华科技园',
        offset: [10, 12]
      },
      events: {
        init: (o) => {
          me.center = [113.584672, 22.345392]
          me.label = {
            content: '清华科技园',
            offset: [10, 12]
          }
          this.getCounterListInMap()
        },
        click (e) {
        }
      },
      searchOption: {
        city: me.city,
        citylimit: true
      },
      plugin: [
        'Scale'
      ]
    }
  },
  methods: {
    closeMap () {
      this.$emit('AmapShow')
    },
    getCounterListInMap () {
      fetch({
        url: '/nb/counter/counterCounterListInMap',
        params: {}
      }).then(data => {
        console.log(data)
        for (let i = 0; i < data.length; i++) {
          let tmpData = {}
          tmpData.id = data[i][2]
          tmpData.position = data[i][1].split(',')
          tmpData.title = data[i][0]
          tmpData.label = {
            content: data[i][3] == null ? '0' : data[i][3],
            offset: [0, 0]
          }
          this.center = tmpData.position
          this.markers.push(tmpData)
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// amapShow.vue?8ca40c30